import { Row, Col, Input, Select, Checkbox, DatePicker } from './../ui/ot';
import React, { useEffect, useState } from 'react';
// import AdminModal from './../classify/components/AdminModal';
import axios from 'axios';
import dayjs from 'dayjs';

const PermissionModal = (props) => {
    const [permission_list, set_permission_list] = useState([]);
    useEffect(() => {
        axios
            .get('/permission_management/permission/list')
            .then((response) => {
                set_permission_list(response.data.data.map(map_item => {
                    return {
                        value: map_item.permission_id,
                        label: map_item.permission_name,
                    };
                }))
            })
    }, [])
    useEffect(() => {
        console.log(props.editcard);
    }, [props.editcard])
    return (
        <>
            {/* {contextHolder}
            <Modal
                // width={'auto'}
                style={{ pointerEvents: 'auto' }}
                open={props.open}
                onOk={props.handleOk}
                bodyStyle={{ backgroundColor: props.edit ? '#faf6f5' : '##FCF5F6' }}
                width={400}
                footer={false}
                data={props.data}
                title={props.title}
                className="modalStyle2"
                wrapClassName={"modalStyle2"}
                modalRender={(e) => <>
                    <div style={{ backgroundColor: props.edit ? '#faf6f5' : '#FCF5F6', padding: '20px', borderTop: `solid #${props.color} 5px `, position: 'relative', height: '80vh' }}>
                        <Row gutter={[10, 10]} justify='center' style={{ minHeight: '65vh', maxHeight: '65vh', overflowY: 'scroll' }}>
                            <Col span={24}>
                                <Row justify="space-between" align={'bottom'}>
                                    {props.edit ?
                                        <>
                                            <img style={{ position: 'relative' }} width="35%" height="35%" src='/cram_school/edit.png'></img>
                                        </> :
                                        <>
                                            <img style={{ position: 'relative' }} width="35%" height="35%" src='/cram_school/add.png'></img>
                                        </>}
                                    <Col span={24} style={{ fontWeight: 'bold', fontSize: '20px', position: 'absolute', zIndex: 99, top: 25, left: 45 }} >{props.title}</Col>
                                    <Col span={24} style={{ fontWeight: 'bold', fontSize: '20px', position: 'absolute', zIndex: 99, top: 55, left: 25 }} >權限管理</Col>
                                </Row>
                            </Col>
                            <Col span={24}> */}
            {/* <AdminModal
                {...props}
                title={(<>
                    <Col span={24} style={{ fontWeight: 'bold', fontSize: '20px', position: 'absolute', zIndex: 99, top: 30, left: 45 }} >{props.title}</Col>
                    <Col span={24} style={{ fontWeight: 'bold', fontSize: '20px', position: 'absolute', zIndex: 99, top: 65, left: 25 }} >權限管理</Col>
                </>)}
                uploads={false}
            >
                <Row gutter={[8, 8]} align={'middle'}>
                    <Col span={6}>人員姓名</Col>
                    <Col span={18}>
                        <Input placeholder={'請輸入人員名稱'} type='text' value={props.editcard.name} name="name" onChange={e => props.setEditCard(pre => ({ ...pre, name: e.target.value }))} autoComplete='off' />
                    </Col>
                    <Col span={6}>人員帳號</Col>
                    <Col span={18}>
                        <Input placeholder={'請輸入人員帳號'} type='text' value={props.editcard.serial_name} name="name" onChange={e => props.setEditCard(pre => ({ ...pre, serial_name: e.target.value }))} autoComplete='off' />
                    </Col>
                    <Col span={6}>人員職位</Col>
                    <Col span={18}>
                        {props.editcard.position}
                    </Col>
                    <Col span={7}>人員權限管理</Col>
                    <Col span={24}>
                        <Checkbox.Group
                            style={{
                                width: '100%',
                            }}
                            value={props.editcard.user_permission_data && props.editcard.user_permission_data.map((item) => item.permission_id)}
                            onChange={checkedValues => {
                                let data_tmp = [];
                                checkedValues.map((item) => { data_tmp.push({ 'permission_id': item, "permission_level_id": 2 }) });
                                props.setEditCard(
                                    pre => ({
                                        ...pre,
                                        user_permission_data: data_tmp
                                    }))
                            }}
                        >
                            <Row gutter={[16, 16]}>
                                {permission_list && permission_list.map((item, i) => {
                                    return (
                                        <Col span={12}>
                                            <Checkbox value={item['value']}>{item['label']}</Checkbox>
                                        </Col>
                                    )
                                })}
                            </Row>
                        </Checkbox.Group>
                    </Col>
                    <Col span={9}>使用起始日</Col>
                    <Col span={15}>
                        <DatePicker style={{ width: '100%' }}
                            value={props.editcard.permission_time_start != null ? dayjs(props.editcard.permission_time_start, 'YYYY-MM-DD') : ''}
                            format={'YYYY-MM-DD'}
                            onChange={(value, dateString) => props.setEditCard(preState => {
                                return (
                                    {
                                        ...preState,
                                        'permission_time_start': dateString,
                                    }
                                )
                            })}
                        />
                    </Col>
                    <Col span={9}>使用結束日</Col>
                    <Col span={15}>
                        <DatePicker style={{ width: '100%' }}
                            value={props.editcard.permission_time_end != null ? dayjs(props.editcard.permission_time_end, 'YYYY-MM-DD') : ''}
                            format={'YYYY-MM-DD'}
                            onChange={(value, dateString) => props.setEditCard(preState => {
                                return (
                                    {
                                        ...preState,
                                        'permission_time_end': dateString,
                                    }
                                )
                            })}
                        />
                    </Col>
                </Row>
            </AdminModal> */}

        </>
    )

}
export default PermissionModal;